module.exports = __webpack_public_path__ + "fonts/iconfont.3c6730de.ttf";